import './globalPolyfill';
import { RouterProvider } from '@tanstack/react-router';
import { initRum } from '@utils/AvRum';
import { createRoot } from 'react-dom/client';
import './index.css';
import './tailwind.css';
import reportWebVitals from './reportWebVitals';
import { useRouterContext } from './RouterContext';
import router from './RouterInit';
import { RouterOuterWrapper } from './RouterOuterWrapper';
import { initializePendoScript } from './utils/pendo/pendo.utils';

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

const RouterWithContextProvider = () => {
  const context = useRouterContext();
  return <RouterProvider router={router} context={context} />;
};

initRum(router);
initializePendoScript();
const container = document.getElementById('root') as Element;
const root = createRoot(container);
root.render(
  <RouterOuterWrapper>
    <RouterWithContextProvider />
  </RouterOuterWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
